import RegisterComponentsContext from '../../components/register-components-context.mjs';
import LiveWaveForm from '../../components/components/plugins/LiveWaveForm.jsx';

RegisterComponentsContext([LiveWaveForm]);